export default __webpack_public_path__ + "static/media/tokiPay.75eab87d.svg";